export const messageKeys = Array.from({ length: 37 }, (_, i) => ({
  titleKey: `messageTitle${i + 1}`,
  subtitleKey: `messageSubtitle${i + 1}`,
}));
